import { useState, useEffect } from "react";
import { api } from "../lib/api";
import { STUDIO } from "../lib/constants";

export function useSettings() {
  const [settings, setSettings] = useState(STUDIO);
  useEffect(() => {
    api.get("/settings").then(({ data }) => {
      if (data && data.address) setSettings((s) => ({ ...s, ...data }));
    }).catch(() => {});
  }, []);
  return settings;
}
